import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'; // Connecting to Redux
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameScene } from './scenes/gameScene';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(PhaserDemo)'
interface PhaserDemoProps {
}

interface PhaserDemoState {
}

const phaserConfig: GameConfig = {
    title: "Phaser Demo", // This needs to be changed
    url: "https://github.com/digitsensitive/phaser3-typescript", // Not needed for anything made by QCI, but for this demo, it is
    version: "1.1", // Required
    width: 768, // You should not fill this in as it is proved by the PhaserGameComponent
    height: 576, // You should not fill this in as it is proved by the PhaserGameComponent
    physics: { // Physics can be added here
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#3A99D9", // Not really needed
    "render.pixelArt": true // 'Anti-Aliasing' when off
};

const templateConfig: GameConfig = {
    title: "Title goes here!",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 999 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserDemo extends React.Component<PhaserDemoProps, PhaserDemoState> {
    private game: Phaser.Game;
    constructor(props: PhaserDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserDemo.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }
    render() {
        return (<div>
            <PhaserGameComponent scenes={GameScene} config={phaserConfig} />
        </div>);
    }
}

export default PhaserDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserDemo/Main.tsx